/**
 * Shared date-range helpers for analytics charts (local timezone).
 */

export function startOfDay(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

export function endOfDay(d) {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
}

export function daysAgo(n) {
  const d = startOfDay(new Date());
  d.setDate(d.getDate() - n + 1);
  return d;
}

/**
 * Resolve chart range from preset + records.
 * Always returns inclusive from/to (end of today if not specified).
 *
 * @param {{ label: string, days: number | null }} preset
 * @param {object[]} records  lean records with optional `at`
 */
export function resolveChartRange(preset, records) {
  const to = endOfDay(new Date());

  if (preset.days != null) {
    return { from: daysAgo(preset.days), to };
  }

  // "All" — earliest registration through today
  let earliest = null;
  for (const r of records) {
    if (!r.at) continue;
    if (!earliest || r.at < earliest) earliest = r.at;
  }

  if (earliest) {
    return { from: startOfDay(earliest), to };
  }

  // No dated records: show last 30 days with zeros
  return { from: daysAgo(30), to };
}
